import { render, staticRenderFns } from "./QualificationItem.vue?vue&type=template&id=713c72b2&scoped=true"
import script from "./QualificationItem.vue?vue&type=script&lang=js"
export * from "./QualificationItem.vue?vue&type=script&lang=js"
import style0 from "./QualificationItem.vue?vue&type=style&index=0&id=713c72b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713c72b2",
  null
  
)

export default component.exports